<app-single-card class="grey-bg">
    <app-login-form></app-login-form>
</app-single-card>